import { useParams } from 'react-router'

import { Template } from '@tribeplatform/gql-client/types'
import { SlateLayout } from '@tribeplatform/react-components/LayoutFrame'
import { useTemplate } from '@tribeplatform/react-sdk/hooks'

import { useQuery } from '../../../../hooks/useQuery.js'

type UseCustomizerTemplate = () => {
  previewHtml: string | undefined
  previewLayout: SlateLayout
}

const extractLayout = (template: Template) => {
  try {
    return JSON.parse(template?.entityProperties)?.layout as SlateLayout
  } catch {
    return undefined
  }
}

export const useCustomizerTemplate: UseCustomizerTemplate = () => {
  const { templateId } = useParams<{ templateId?: string }>()
  const { spaceId } = useQuery<{ spaceId?: string }>()

  // If the 'spaceId' exists in the query parameters, the template previewHtml should not be used.
  // This is because we are on the 'edit template' page and the display should be the 'space slate' instead.
  const shouldUseTemplate = !!templateId && !spaceId

  const { data: template } = useTemplate({
    variables: {
      id: templateId,
    },
    fields: 'basic',
    useQueryOptions: {
      enabled: shouldUseTemplate,
    },
  })

  const previewHtml = shouldUseTemplate ? template?.previewHtml : undefined
  const previewLayout = extractLayout(template) ?? SlateLayout.headerSidebar

  return { previewHtml, previewLayout }
}
